import { useState } from 'react';
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { EbbeModalObject, EbbeModalVurgu, storeEbbeModalCallback } from '../redux/reducers/authSlice';

// Renkli bilgi kutusu renkleri (17.10.2026): e-Arşiv turuncu, e-Fatura mavi, iptal kırmızı.
const VURGU_RENK: Record<EbbeModalVurgu['renk'], { yazi: string, zemin: string }> = {
    turuncu: { yazi: '#ea580c', zemin: '#fff3e8' },
    mavi: { yazi: '#1b84ff', zemin: '#e9f3ff' },
    kirmizi: { yazi: '#e11d48', zemin: '#ffeef2' },
    yesil: { yazi: '#16a34a', zemin: '#eafbf0' },
};

const BelgeIkonu = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><path d="M14 2v6h6" /><path d="M9 13h6M9 17h4" />
    </svg>
);

interface Props {
    isShown: boolean
    params: EbbeModalObject | undefined
}

const EbbeModal = ({ isShown, params }: Props) => {
    const dispatch = useDispatch();
    const [deviceNo, setDeviceNo] = useState('');
    const [plate, setPlate] = useState('');
    const [vehicleTypeId, setVehicleTypeId] = useState('');
    const [file, setFile] = useState<File | undefined>(undefined);

    const onCustomClose = (_state: boolean) => {
        if (params && params.onClose && _state)
            params.onClose();

        dispatch(storeEbbeModalCallback(undefined));
    }

    return (
        <Modal
            id='kt_modal_create_app'
            tabIndex={-1}
            aria-hidden='true'
            dialogClassName={'modal-dialog modal-dialog-centered ' + (params?.vurgu ? 'mw-600px' : 'mw-900px')}
            show={isShown}
            onHide={() => onCustomClose(false)}
            backdrop={'static'}
            keyboard={false}
        >
            {params?.vurgu ? (
                <div className='modal-body px-8 pt-7 pb-5'>
                    <div className='fs-3 fw-bold text-gray-900 mb-4'>{params.title}</div>
                    <div className='rounded-2 px-5 py-4' style={{ background: VURGU_RENK[params.vurgu.renk].zemin, borderLeft: '4px solid ' + VURGU_RENK[params.vurgu.renk].yazi }}>
                        <div className='d-flex align-items-center gap-2 fw-bold fs-6 mb-1' style={{ color: VURGU_RENK[params.vurgu.renk].yazi }}>
                            <BelgeIkonu />{params.vurgu.baslik}
                        </div>
                        <div className='fs-6 text-gray-800 lh-lg'>
                            {params.vurgu.kalin && <span className='fw-bold'>{params.vurgu.kalin} </span>}{params.vurgu.metin}
                        </div>
                    </div>
                    {params.vurgu.soru && <div className='fs-6 fw-semibold text-gray-800 mt-4'>{params.vurgu.soru}</div>}
                </div>
            ) : (
                <div className='modal-body'>
                    <h1>{params?.title}</h1>
                    <h3>{params?.body}</h3>
                </div>
            )}

            <div className="modal-footer">
                {
                    params?.buttons.map((item, index) => (
                        <button
                            onClick={() => {
                                if (item.onClick)
                                    item.onClick();

                                onCustomClose(false);
                            }}
                            type="button"
                            className={"btn " + item.btnClass}
                        >
                            {item.text}
                        </button>
                    ))
                }
            </div>
        </Modal>
    )
}

export default EbbeModal;